import { FC } from 'react';
import { Gray50 } from '@traceair/tds';

// Rendered as a plain in-flow flex item (width 56, height matching the row) alongside the row's
// content — its own box reserves the row's left gutter, so no padding/positioning trick is
// needed on the row itself to make room for it.
const WIDTH = 56;
const HEIGHT = 40;
// The trunk sits 12px in from the connector's right edge (close to the row content it feeds
// into), not centered in the gutter.
const TRUNK_X = WIDTH - 12;
const CURVE_RADIUS = 4;
const BRANCH_Y = HEIGHT / 2; // vertical center of the row, where the branch meets the content
const CURVE_START_Y = BRANCH_Y - CURVE_RADIUS;
const CURVE_END_X = TRUNK_X + CURVE_RADIUS;
// Rounded quarter-turn from vertical to horizontal, starting at (TRUNK_X, CURVE_START_Y).
const curve = `C${TRUNK_X} ${CURVE_START_Y + 2.2091} ${
  TRUNK_X + 1.79086
} ${BRANCH_Y} ${CURVE_END_X} ${BRANCH_Y}H${WIDTH}`;

// Non-last rows: the trunk runs the row's full height so it lines up seamlessly with the next
// sibling's trunk, with a rounded branch peeling off at the row's vertical center.
const MiddleConnector: FC = () => (
  <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} fill="none">
    <path d={`M${TRUNK_X} 0V${HEIGHT}`} stroke={Gray50} />
    <path d={`M${TRUNK_X} ${CURVE_START_Y}${curve}`} stroke={Gray50} />
  </svg>
);

// Last row: the trunk stops halfway down and curves into the branch — it never reaches the
// row's bottom edge, since there's no further sibling for it to continue into.
const LastConnector: FC = () => (
  <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} fill="none">
    <path d={`M${TRUNK_X} 0V${CURVE_START_Y}${curve}`} stroke={Gray50} />
  </svg>
);

// Vertical/elbow "tree" line rendered to the left of a nested item row, showing it as a child of
// the category header above (e.g. "Scans, panoramas price" · "GCP services").
export const TreeConnector: FC<{ isLast: boolean }> = ({ isLast }) =>
  isLast ? <LastConnector /> : <MiddleConnector />;
